/* eslint-disable max-len */
import glamorous from "glamorous";
import { mediaQueries } from "../../../constants/mediaqueries.const";
import highFiveLockup from "../../../images/HighFive_Logo_Swoosh_LeftAligned.svg";


const ndeBlack = "#061B38";

// Main wrapper
export const DashboardManagerPageWrapper = glamorous.div("ncss-container fixed-fluid", () => ({
  paddingTop: "56px",
  paddingBottom: "48px",
  backgroundColor: "#f4f4f4"
}));
DashboardManagerPageWrapper.displayName = "DashboardManagerPageWrapper";

// First Row to conatin Sent and Received and Graphs
export const DashboardRowOneWrapper = glamorous.div("ncss-row-sm-12", () => ({
  paddingRight: "40px",
  paddingLeft: "40px",
}));
DashboardRowOneWrapper.displayName = "DashboardRowOneWrapper";

// Box to contain Sent and Received H5 on the right
export const SentReceivedBoxWrapper = glamorous.div("ncss-col-sm-3 ta-sm-c ", () =>({
}))
SentReceivedBoxWrapper.displayName = "SentReceivedBoxWrapper";

// Actual box and background
export const BoxContainer = glamorous.div("ncss-row-sm-12 ", () =>({
  [mediaQueries.tablet]: {
    height: "270px",
  },
  [mediaQueries.desktop]: {
    height: "290px",
  },
  height: "190px",
  color: "#ffffff",
  background: "#061b38",
}))
BoxContainer.displayName = "BoxContainer";

// Number container
export const SentReceivedContainer = glamorous.div("ncss-col-sm-6 ta-sm-c mt6-sm ncss-marketing", () =>({
  [mediaQueries.tablet]: {
    fontSize: "75px",
  },
  fontSize:"40px",
  width: "50%",
}))
SentReceivedContainer.displayName = "SentReceivedContainer";

export const ReceivedContainer = glamorous.div("ncss-col-sm-6 ta-sm-c mt6-sm ncss-marketing", () =>({
  [mediaQueries.tablet]: {
    fontSize: "75px",
  },
  fontSize:"40px",
  width: "50%",
  color: "#061b38",
}))
ReceivedContainer.displayName = "ReceivedContainer";


// Title for sent and received
export const SentReceivedTitleWrapper = glamorous.div("ncss-col-sm-6 ta-sm-c ncss-base", () =>({
  [mediaQueries.tablet]: {
    fontSize: "20px",
  },
  fontSize:"10px",
  width: "50%",
}))
SentReceivedTitleWrapper.displayName = "SentReceivedTitleWrapper";

// Title for sent and received
export const ExportTitleWrapper = glamorous.div("ncss-row-sm-12 ta-sm-c ncss-base", () =>({
  [mediaQueries.tablet]: {
    fontSize: "20px",
  },
  marginTop: "20px",
  fontSize:"10px",
  width: "100%",
}))
ExportTitleWrapper.displayName = "ExportTitleWrapper";

// Graph to contain Sent and Received H5 on the right
export const GraphWrapper = glamorous.div("ncss-col-sm-9", () =>({
  paddingRight: "40px",
  marginBottom: "30px"
}))
GraphWrapper.displayName = "GraphWrapper";

// Graph to contain Sent and Received H5 on the right
export const GraphInlineWrapper = glamorous.div("ncss-col-sm-12", () =>({
  backgroundColor: "#ffffff",
  width: "100%", 
  height: 500
}))
GraphInlineWrapper.displayName = "GraphInlineWrapper";

export const TableWrapper = glamorous.div("", () =>({
  paddingRight: "48px",
  paddingLeft: "48px",
  width: "100%", 
}))
TableWrapper.displayName = "TableWrapper";

export const OverviewWrapper = glamorous.div("ncss-base", () => ({
  paddingRight: "48px",
  paddingLeft: "48px",
  marginBottom: "10px",
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  flexDirection: "row",
  color: "#333",
  height: "48px",
  lineHeight: "48px",
  fontSize: "12px",
  "> a": {
    borderBottom: "2px solid transparent",
    transition: "border-color 0.2s ease-in",
    "&:hover": {
      borderColor: ndeBlack,
    },
  },
}))
OverviewWrapper.displayName = "OverviewWrapper";

export const TabContainer = glamorous.div("ncss-base prl4-sm prl6-md pb10-sm", () => ({
  [mediaQueries.tablet]: {
    fontSize: "12px",
  },
  [mediaQueries.desktop]: {
    fontSize: "14px",
  },
  position: "relative",
  fontSize: "10px",
  width: "30%",
  height: "48px",
  lineHeight: "48px",
  top: 0,
  display: "flex",
  justifyContent: "space-around",
  "> button": {
    borderBottom: "2px solid transparent",
    transition: "border-color 0.2s ease-in",
    "&:hover": {
      borderColor: ndeBlack,
    },
  },
}));
TabContainer.displayName = "TabContainer";

export const HistoryWrapper = glamorous.div("", () =>({
  [mediaQueries.tablet]: {
    fontSize: "30px",
  },
  fontSize:"20px",
  fontFamily: "HelveticaNeue-Medium",
  fontWeight: "500px"
}))
HistoryWrapper.displayName = "HistoryWrapper";

export const SentRecTabContainer = glamorous.div("ncss-base prl4-sm prl6-md pb10-sm", () => ({
  [mediaQueries.tablet]: {
    fontSize: "16px",
  },
  [mediaQueries.desktop]: {
    fontSize: "14px",
  },
  position: "relative",
  fontSize: "12px",
  width: "17%",
  height: "48px",
  // lineHeight: "48px",
  top: 0,
  display: "flex",
  justifyContent: "space-between",
  "> button": {
    borderBottom: "2px solid transparent",
    transition: "border-color 0.2s ease-in",
    "&:hover": {
      borderColor: ndeBlack,
    },
  },
}));
SentRecTabContainer.displayName = "SentRecTabContainer";

export const HighFiveLockup = glamorous.div(() => ({
  display: "inline-block",
  width: "300px",  
  height: "80px",
  background: `url(${highFiveLockup}) no-repeat center center`,
  backgroundSize: "contain !important",
  marginLeft: "10px"
}));
HighFiveLockup.displayName = "HighFiveLockup";

export const DashboardUserBanner = glamorous.div("ncss-col-sm-12", () =>({
  padding: "0",
  justifyContent: "space-between",
  backgroundColor: "#ffffff",  
  height: "80px",
  display: "flex",
  flexDirection: "row",
}))
DashboardUserBanner.displayName = "DashboardUserBanner";


export const UserTabContainer = glamorous.div("ncss-base", () => ({
  [mediaQueries.tablet]: {
    fontSize: "12px",
  },
  [mediaQueries.desktop]: {
    fontSize: "14px",
  },
  height: "80px",
  lineHeight: "80px",
  position: "relative",
  fontSize: "10px",
  width: "45%",
  top: 0,
  display: "flex",
  justifyContent: "space-around",
  "> button": {
    borderBottom: "2px solid transparent",
    transition: "border-color 0.2s ease-in",
    "&:hover": {
      borderColor: ndeBlack,
    },
  },
}));
UserTabContainer.displayName = "UserTabContainer";

export const UserBannerTopWrapper = glamorous.div("ncss-base", () => ({
  paddingRight: "48px",
  paddingLeft: "48px",
  height: "80px",
  marginBottom: "93px",
  display: "flex",
  width: "100%",
  justifyContent: "space-between",
  flexDirection: "row",
  color: "#333",
  lineHeight: "48px",
  fontSize: "12px",
  "> a": {
    borderBottom: "2px solid transparent",
    transition: "border-color 0.2s ease-in",
    "&:hover": {
      borderColor: ndeBlack,
    },
  },
}))
UserBannerTopWrapper.displayName = "UserBannerTopWrapper";

export const GraphBannerWrapper = glamorous.div("ncss-col-sm-9", () =>({
  [mediaQueries.tablet]: {
    fontSize: "30px",
  },
  verticalAlign: "top",
  justifyContent: "space-around",
  fontSize:"20px",
  fontFamily: "HelveticaNeue-Medium",
  fontWeight: "500px"
}))
GraphBannerWrapper.displayName = "GraphBannerWrapper";

export const DropDownBoxWrapper = glamorous.div("ncss-col-sm-3 ta-sm-c ", () =>({
  verticalAlign: "top",
  margin: "0",
  paddingRight: "20px",
}))
DropDownBoxWrapper.displayName = "DropDownBoxWrapper";

export const FilterWrapper = glamorous.div("ncss-col-sm-3 ncss-base", () => ({
  [mediaQueries.tablet]: {
    fontSize: "16px",
  },
  [mediaQueries.desktop]: {
    fontSize: "14px",
  },
  fontSize: "12px",
  height: "56px",
  display: "flex",
  paddingLeft: "40px",
  "> button": {
    borderBottom: "2px solid transparent",
    transition: "border-color 0.2s ease-in",
    "&:hover": {
      borderColor: ndeBlack,
    },
  },
}));
FilterWrapper.displayName = "FilterWrapper";

export const FlyoutWrapper = glamorous.div("ncss-flyout ncss-brand ", () => ({
}))
FlyoutWrapper.displayName = "FlyoutWrapper";

export const FlyoutInsideWrapper = glamorous.div("ncss-flyout-btn border-light-grey", () => ({
  marginTop: "10px",
  width: "150px"
}))
FlyoutInsideWrapper.displayName = "FlyoutInsideWrapper";

export const FlyoutWrapperOptions = glamorous.div("ncss-flyout-options", () => ({
}))
FlyoutWrapperOptions.displayName = "FlyoutWrapperOptions";







// WEBPACK FOOTER //
// ./src/containers/DashboardPage/DashboardManager/DashboardManager.style.js